import { isPlainObject } from 'lodash';
import { LOCALES } from '@/locales/i18n';

const defaultLang = 'en';

/**
 * Old code using the getter lang, we should use userLang or siteLang getters.
 */
export default {
    getters: {
        /**
         * @param {Object} state
         * @param {Object} getters
         * @return {String}
         */
        lang: (state, getters) => {
            const { user } = getters;

            if (!isPlainObject(user)) {
                return defaultLang;
            }

            return user.lang;
        },

        /**
         * Alias of lang getter
         *
         * @param {Object} state
         * @param {Object} getters
         * @return {String}
         */
        userLang: (state, getters) => getters.lang,

        /**
         * @param {Object} state
         * @param {Object} getters
         * @return {String}
         */
        siteLang: (state, getters) => {
            const { site, labWorkOrder, lang } = getters;
            if (!isPlainObject(site)) {
                return defaultLang;
            }
            return site?.lang || labWorkOrder?.site?.lang || lang || defaultLang;
        },

        /**
         * @TODO
         * @return {Array}
         */
        teamLangs: () => LOCALES,
    },
};
